import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { EsportsSlidesRoutes } from "./esports-slides.routes";
import { EsportsSlideListComponent } from "./esports-slide-list/esports-slide-list.component";
import { EsportsSlideFormComponent } from "./esports-slide-form/esports-slide-form.component";
import { EsportsSlideService, EsportsSlideFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    EsportsSlidesRoutes,
  ],
  declarations: [EsportsSlideListComponent, EsportsSlideFormComponent],
  providers: [EsportsSlideService, EsportsSlideFormService],
})
export class EsportsSlidesModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/esports-slides.module.ts